"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5249,2576,5124,949],{

/***/ 29263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_ColumnTrack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85735);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6580);
/* harmony import */ var _segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74881);
/* harmony import */ var _segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94136);
/* harmony import */ var _segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88392);
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43848);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52903);












var copy = {
  heading: "Additional Resources"
};
var data = [{
  slug: "/growth-center/",
  title: "Growth Center",
  description: "Learn how to implement and scale high-performing growth strategies.",
  cta: "Visit our Growth Center"
}, {
  slug: "https://segment.com/blog/",
  title: "Our Blog",
  description: "Stay up-to-date with our latest articles on all things data.",
  cta: "Read our blog"
}, {
  slug: "/good-data-better-marketing/",
  title: "Good Data, Better Marketing",
  description: "Tune in to hear from enterprise experts as they share how to use data as a competitive asset to drive customer engagement.",
  cta: "Listen to our podcast"
}];
var AdditionalResources = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function () {
  var pageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_8__/* .usePageConfig */ .Gm)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(StyledSection, {
    variant: "centered",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_7__/* .Copy */ .CK, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
        centered: true,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_CopyText__WEBPACK_IMPORTED_MODULE_6__/* .Heading */ .X6, {
          tag: "h2",
          variant: "h2",
          children: copy.heading
        })
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_7__/* .Contents */ .AU, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_components_ColumnTrack__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        columns: 1,
        overrides: {
          lg: 3
        },
        children: data.map(function (_ref) {
          var slug = _ref.slug,
              title = _ref.title,
              description = _ref.description,
              cta = _ref.cta;
          return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
            href: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("".concat(slug), pageConfig),
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__/* .Copy */ .CK, {
                children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__/* .Headline */ .s0, {
                  tag: "h3",
                  children: title
                }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__/* .Description */ .dk, {
                  children: description
                })]
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_recipes_Card__WEBPACK_IMPORTED_MODULE_5__/* .Action */ .aU, {
                alignment: "left",
                children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                  iconEnd: _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_4__/* .ChevronRightIcon */ .XC,
                  children: cta
                })
              })]
            })
          }, slug);
        })
      })
    })]
  });
});

var StyledSection = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP,  true ? {
  target: "eskhgws0"
} : 0)("padding-bottom:40px;", _segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_7__/* .Wrapper */ .im, "{row-gap:50px;}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding-bottom:80px;}" + ( true ? "" : 0));

/* harmony default export */ __webpack_exports__["Z"] = (AdditionalResources);

/***/ }),

/***/ 33947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_components_Divider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76305);
/* harmony import */ var _segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88392);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52903);





var ResourcesDivider = function ResourcesDivider() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_2__/* .Contents */ .AU, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_segment_matcha_components_Divider__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
    })
  });
};

var StyledSectionBase = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP,  true ? {
  target: "e5492tw0"
} : 0)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_2__/* .Wrapper */ .im, "{padding-top:0;padding-bottom:0;}" + ( true ? "" : 0));

/* harmony default export */ __webpack_exports__["Z"] = (ResourcesDivider);

/***/ }),

/***/ 82682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p8": function() { return /* binding */ useResourcesIndex; },
/* harmony export */   "vS": function() { return /* binding */ AlgoliaClientProvider; }
/* harmony export */ });
/* unused harmony exports algoliaClientContext, useAlgoliaClient, createResourcesIndex */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var algoliaClientContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var AlgoliaClientProvider = algoliaClientContext.Provider;
var useAlgoliaClient = function useAlgoliaClient() {
  var AlgoliaClient = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(algoliaClientContext);

  if (!AlgoliaClient) {
    throw new Error("Resources index isn't available. Please set it via AlgoliaClientProvider component.");
  }

  return AlgoliaClient;
};
var useResourcesIndex = function useResourcesIndex() {
  var client = useAlgoliaClient();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return createResourcesIndex(client);
  }, [client]);
};
var createResourcesIndex = function createResourcesIndex(client) {
  var _process$env$NEXT_PUB;

  var internalClient = client;
  return internalClient.initIndex((_process$env$NEXT_PUB = "Resources") !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "");
};

/***/ }),

/***/ 41472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Nv": function() { return /* reexport */ useFeaturedResourcesQuery; },
  "s_": function() { return /* reexport */ useFiltersQuery; },
  "nO": function() { return /* reexport */ useResourcesQuery; },
  "oB": function() { return /* reexport */ useSingleResourceQuery; }
});

// UNUSED EXPORTS: createAllResourcesQuery, createFeaturedResourcesQuery, createFiltersQuery, createResourcesQuery, createSingleResourceQuery, useAllResourcesQuery

// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var staticSiteBackend = __webpack_require__(86708);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(829);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/resources.ts






function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var fetchAllResources = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, options) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", client.get("/content/entries/resource", options).then(function (res) {
              var transformedResponse = res.map(function (resource) {
                var _resource$image$field, _resource$image, _resource$image$field2, _resource$image$field3, _resource$image$field4, _resource$image2, _resource$image2$fiel, _resource$image$field5, _resource$image3, _resource$image3$fiel, _resource$image3$fiel2, _resource$image3$fiel3, _resource$image3$fiel4, _resource$image$field6, _resource$image4, _resource$image4$fiel, _resource$image4$fiel2, _resource$image4$fiel3, _resource$image4$fiel4, _resource$resourceSin, _resource$resourceSin2, _resource$resourceSin3, _resource$resourceSin4, _resource$resourceSin5, _resource$resourceSin6, _resource$resourceSin7, _resource$resourceSin8, _resource$resourceSin9, _resource$resourceSin10, _resource$resourceSin11, _resource$resourceSin12, _resource$resourceSin13, _resource$resourceSin14, _resource$resourceSin15, _resource$resourceSin16, _resource$resourceSin17, _resource$resourceSin18, _resource$resourceSin19, _resource$resourceSin20, _resource$resourceSin21;

                return _objectSpread(_objectSpread({}, resource), {}, {
                  image: {
                    src: (_resource$image$field = (_resource$image = resource.image) === null || _resource$image === void 0 ? void 0 : (_resource$image$field2 = _resource$image.fields) === null || _resource$image$field2 === void 0 ? void 0 : (_resource$image$field3 = _resource$image$field2.file) === null || _resource$image$field3 === void 0 ? void 0 : _resource$image$field3.url) !== null && _resource$image$field !== void 0 ? _resource$image$field : "",
                    title: (_resource$image$field4 = (_resource$image2 = resource.image) === null || _resource$image2 === void 0 ? void 0 : (_resource$image2$fiel = _resource$image2.fields) === null || _resource$image2$fiel === void 0 ? void 0 : _resource$image2$fiel.title) !== null && _resource$image$field4 !== void 0 ? _resource$image$field4 : "",
                    width: (_resource$image$field5 = (_resource$image3 = resource.image) === null || _resource$image3 === void 0 ? void 0 : (_resource$image3$fiel = _resource$image3.fields) === null || _resource$image3$fiel === void 0 ? void 0 : (_resource$image3$fiel2 = _resource$image3$fiel.file) === null || _resource$image3$fiel2 === void 0 ? void 0 : (_resource$image3$fiel3 = _resource$image3$fiel2.details) === null || _resource$image3$fiel3 === void 0 ? void 0 : (_resource$image3$fiel4 = _resource$image3$fiel3.image) === null || _resource$image3$fiel4 === void 0 ? void 0 : _resource$image3$fiel4.width) !== null && _resource$image$field5 !== void 0 ? _resource$image$field5 : "",
                    height: (_resource$image$field6 = (_resource$image4 = resource.image) === null || _resource$image4 === void 0 ? void 0 : (_resource$image4$fiel = _resource$image4.fields) === null || _resource$image4$fiel === void 0 ? void 0 : (_resource$image4$fiel2 = _resource$image4$fiel.file) === null || _resource$image4$fiel2 === void 0 ? void 0 : (_resource$image4$fiel3 = _resource$image4$fiel2.details) === null || _resource$image4$fiel3 === void 0 ? void 0 : (_resource$image4$fiel4 = _resource$image4$fiel3.image) === null || _resource$image4$fiel4 === void 0 ? void 0 : _resource$image4$fiel4.height) !== null && _resource$image$field6 !== void 0 ? _resource$image$field6 : ""
                  },
                  resourceSingle: _objectSpread(_objectSpread({}, (_resource$resourceSin = resource.resourceSingle) === null || _resource$resourceSin === void 0 ? void 0 : _resource$resourceSin.fields), {}, {
                    socialImage: {
                      src: (_resource$resourceSin2 = resource.resourceSingle) === null || _resource$resourceSin2 === void 0 ? void 0 : _resource$resourceSin2.fields.socialImage.fields.file.url,
                      title: (_resource$resourceSin3 = resource.resourceSingle) === null || _resource$resourceSin3 === void 0 ? void 0 : _resource$resourceSin3.fields.socialImage.fields.title,
                      width: (_resource$resourceSin4 = resource.resourceSingle) === null || _resource$resourceSin4 === void 0 ? void 0 : (_resource$resourceSin5 = _resource$resourceSin4.fields.socialImage.fields.file.details.image) === null || _resource$resourceSin5 === void 0 ? void 0 : _resource$resourceSin5.width,
                      height: (_resource$resourceSin6 = resource.resourceSingle) === null || _resource$resourceSin6 === void 0 ? void 0 : (_resource$resourceSin7 = _resource$resourceSin6.fields.socialImage.fields.file.details.image) === null || _resource$resourceSin7 === void 0 ? void 0 : _resource$resourceSin7.height
                    },
                    resourcePromo: _objectSpread(_objectSpread({}, (_resource$resourceSin8 = resource.resourceSingle) === null || _resource$resourceSin8 === void 0 ? void 0 : (_resource$resourceSin9 = _resource$resourceSin8.fields.resourcePromo) === null || _resource$resourceSin9 === void 0 ? void 0 : _resource$resourceSin9.fields), {}, {
                      image: {
                        src: (_resource$resourceSin10 = resource.resourceSingle) === null || _resource$resourceSin10 === void 0 ? void 0 : (_resource$resourceSin11 = _resource$resourceSin10.fields.resourcePromo) === null || _resource$resourceSin11 === void 0 ? void 0 : _resource$resourceSin11.fields.image.fields.file.url,
                        title: (_resource$resourceSin12 = resource.resourceSingle) === null || _resource$resourceSin12 === void 0 ? void 0 : (_resource$resourceSin13 = _resource$resourceSin12.fields.resourcePromo) === null || _resource$resourceSin13 === void 0 ? void 0 : _resource$resourceSin13.fields.image.fields.title,
                        width: (_resource$resourceSin14 = resource.resourceSingle) === null || _resource$resourceSin14 === void 0 ? void 0 : (_resource$resourceSin15 = _resource$resourceSin14.fields.resourcePromo) === null || _resource$resourceSin15 === void 0 ? void 0 : (_resource$resourceSin16 = _resource$resourceSin15.fields.image.fields.file.details.image) === null || _resource$resourceSin16 === void 0 ? void 0 : _resource$resourceSin16.width,
                        height: (_resource$resourceSin17 = resource.resourceSingle) === null || _resource$resourceSin17 === void 0 ? void 0 : (_resource$resourceSin18 = _resource$resourceSin17.fields.resourcePromo) === null || _resource$resourceSin18 === void 0 ? void 0 : (_resource$resourceSin19 = _resource$resourceSin18.fields.image.fields.file.details.image) === null || _resource$resourceSin19 === void 0 ? void 0 : _resource$resourceSin19.height
                      }
                    }),
                    faqs: (_resource$resourceSin20 = resource.resourceSingle) === null || _resource$resourceSin20 === void 0 ? void 0 : (_resource$resourceSin21 = _resource$resourceSin20.fields.faqs) === null || _resource$resourceSin21 === void 0 ? void 0 : _resource$resourceSin21.map(function (_ref2) {
                      var fields = _ref2.fields;
                      return fields;
                    })
                  })
                });
              });
              return sortBy_default()(transformedResponse, ["title"]);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchAllResources(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchFeaturedResources = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref3) {
    var client, _ref3$max, max, options, data;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            client = _ref3.client, _ref3$max = _ref3.max, max = _ref3$max === void 0 ? 3 : _ref3$max, options = _ref3.options;
            _context2.next = 3;
            return fetchAllResources(client, options);

          case 3:
            data = _context2.sent.filter(function (item) {
              return item.featured;
            }).slice(0, max);
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchFeaturedResources(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
var fetchResource = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var client, options, url, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            client = _ref5.client, options = _ref5.options, url = _ref5.url;
            _context3.next = 3;
            return fetchAllResources(client, options);

          case 3:
            data = _context3.sent.find(function (item) {
              return item.url === url;
            });
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchResource(_x4) {
    return _ref6.apply(this, arguments);
  };
}()));
var fetchSingleResource = /*#__PURE__*/function () {
  var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(_ref7) {
    var client, options, url, data;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            client = _ref7.client, options = _ref7.options, url = _ref7.url;
            _context4.next = 3;
            return fetchAllResources(client, options);

          case 3:
            data = _context4.sent.find(function (item) {
              var _item$resourceSingle;

              return ((_item$resourceSingle = item.resourceSingle) === null || _item$resourceSingle === void 0 ? void 0 : _item$resourceSingle.url) === url;
            });
            return _context4.abrupt("return", data === null || data === void 0 ? void 0 : data.resourceSingle);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchSingleResource(_x5) {
    return _ref8.apply(this, arguments);
  };
}();
var fetchFilters = /*#__PURE__*/function () {
  var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(_ref9) {
    var client, filtersObjs, options, allResources, filters;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            client = _ref9.client, filtersObjs = _ref9.filtersObjs, options = _ref9.options;
            _context5.next = 3;
            return fetchAllResources(client, options);

          case 3:
            allResources = _context5.sent;
            filters = filtersObjs.map(function (_ref11) {
              var id = _ref11.id,
                  displayName = _ref11.displayName,
                  searchableId = _ref11.searchableId;
              var options = allResources.reduce(function (acc, resource) {
                if (resource[id]) {
                  var value = resource[id];
                  if (typeof value === "string") acc.push(value);else if (Array.isArray(value)) acc.push.apply(acc, (0,toConsumableArray/* default */.Z)(value));else {
                    throw new Error("Unexpected value type for filter ".concat(id));
                  }
                }

                return acc;
              }, []);
              return {
                id: id,
                searchableId: searchableId,
                displayName: displayName,
                options: sortBy_default()(Array.from(new Set(options)).map(function (option) {
                  return {
                    value: option,
                    text: option
                  };
                }), function (opt) {
                  return opt.value.toLowerCase();
                })
              };
            });
            return _context5.abrupt("return", filters);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchFilters(_x6) {
    return _ref10.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/api/routes/resources/queries/allResourcesQuery.tsx



var createAllResourcesQuery = function createAllResourcesQuery(client) {
  return [["resources", "allResourcesQuery"], function () {
    return fetchAllResources(client);
  }];
};
var useAllResourcesQuery = (0,createQueryHook/* default */.Z)(createAllResourcesQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/resources/queries/featuredResourcesQuery.ts



var createFeaturedResourcesQuery = function createFeaturedResourcesQuery(client, _ref) {
  var max = _ref.max;
  return [["resources", "featuredResourcesQuery", max], function (_ref2) {
    var signal = _ref2.signal;
    return fetchFeaturedResources({
      client: client,
      max: max,
      options: {
        signal: signal
      }
    });
  }];
};
var useFeaturedResourcesQuery = (0,createQueryHook/* default */.Z)(createFeaturedResourcesQuery, staticSiteBackend/* useStaticSiteBackend */.gR);
;// CONCATENATED MODULE: ../../libs/api/routes/resources/queries/filtersQuery.ts



var defaultFilters = [{
  id: "label",
  searchableId: "label",
  displayName: "Type of content"
}, {
  id: "tags",
  searchableId: "tags",
  displayName: "Topic"
}];
var createFiltersQuery = function createFiltersQuery(client) {
  var filtersObjs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFilters;
  return [["resources", "filters"], function (_ref) {
    var signal = _ref.signal;
    return fetchFilters({
      client: client,
      filtersObjs: filtersObjs,
      options: {
        signal: signal
      }
    });
  }];
};
var useFiltersQuery = (0,createQueryHook/* default */.Z)(createFiltersQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
// EXTERNAL MODULE: ../../libs/utils/createInfinityQueryHook/createInfinityQueryHook.ts
var createInfinityQueryHook = __webpack_require__(99338);
// EXTERNAL MODULE: ../../libs/utils/fsCache/index.ts
var fsCache = __webpack_require__(96904);
;// CONCATENATED MODULE: ../../libs/api/algolia/resources.ts
/* provided dependency */ var process = __webpack_require__(34406);





function resources_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function resources_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? resources_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : resources_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var attributesToFetch = ["title", "url", "image", "label", "tags", "description", "cta", "featured"];
var fetchResources = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var query, searchIndex, _ref$page, page, _ref$distinct, distinct, hitsPerPage, filters, cacheKey, enabled, algoliaCachedSearch;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, searchIndex = _ref.searchIndex, _ref$page = _ref.page, page = _ref$page === void 0 ? 0 : _ref$page, _ref$distinct = _ref.distinct, distinct = _ref$distinct === void 0 ? 0 : _ref$distinct, hitsPerPage = _ref.hitsPerPage, filters = _ref.filters, cacheKey = _ref.cacheKey;
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 4;
            return (0,fsCache/* createFsCacheProxy */.c)(["resources-fetchResources"].concat((0,toConsumableArray/* default */.Z)(cacheKey ? cacheKey : [query, page !== null && page !== void 0 ? page : null, distinct !== null && distinct !== void 0 ? distinct : null, hitsPerPage !== null && hitsPerPage !== void 0 ? hitsPerPage : null, filters !== null && filters !== void 0 ? filters : null])), function () {
              return searchIndex.search.apply(searchIndex, arguments).then(function (res) {
                return resources_objectSpread(resources_objectSpread({}, res), {}, {
                  hits: res.hits.map(function (hit) {
                    var _hit$image, _hit$image2;

                    return resources_objectSpread(resources_objectSpread({}, hit), {}, {
                      image: {
                        src: (_hit$image = hit.image) === null || _hit$image === void 0 ? void 0 : _hit$image.src,
                        title: (_hit$image2 = hit.image) === null || _hit$image2 === void 0 ? void 0 : _hit$image2.alt
                      }
                    });
                  })
                });
              });
            }, {
              enabled: enabled
            });

          case 4:
            algoliaCachedSearch = _context.sent;
            return _context.abrupt("return", algoliaCachedSearch(query, {
              attributesToRetrieve: ["-*"].concat(attributesToFetch),
              distinct: distinct,
              page: page,
              hitsPerPage: hitsPerPage,
              filters: filters
            }));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchResources(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ../../libs/api/routes/resources/contexts/algoliaClientContext.ts
var algoliaClientContext = __webpack_require__(82682);
;// CONCATENATED MODULE: ../../libs/api/routes/resources/queries/resourcesQuery.ts





var createResourcesQuery = function createResourcesQuery(searchIndex, _ref) {
  var query = _ref.query,
      hitsPerPage = _ref.hitsPerPage,
      filters = _ref.filters;
  return [["resources", "resourcesQuery", query, hitsPerPage, filters], /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
      var pageParam;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pageParam = _ref2.pageParam;
              return _context.abrupt("return", fetchResources({
                searchIndex: searchIndex,
                page: pageParam,
                query: query,
                filters: filters,
                hitsPerPage: 6
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()];
};
var useResourcesQuery = (0,createInfinityQueryHook/* default */.Z)(createResourcesQuery, algoliaClientContext/* useResourcesIndex */.p8, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(_ref4) {
    var _ref4$page = _ref4.page,
        page = _ref4$page === void 0 ? 0 : _ref4$page;
    var prevPage = page - 1;

    if (prevPage < 0) {
      return;
    }

    return prevPage;
  },
  getNextPageParam: function getNextPageParam(_ref5) {
    var _ref5$page = _ref5.page,
        page = _ref5$page === void 0 ? 0 : _ref5$page,
        nbPages = _ref5.nbPages;
    var nextPage = page + 1;

    if (nextPage >= nbPages) {
      return;
    }

    return nextPage;
  }
});
;// CONCATENATED MODULE: ../../libs/api/routes/resources/queries/singleResourceQuery.tsx



var createSingleResourceQuery = function createSingleResourceQuery(client, slug) {
  return [["resources/singleResourceQuery", slug], function () {
    return fetchSingleResource({
      client: client,
      url: "/resources/".concat(slug, "/")
    });
  }];
};
var useSingleResourceQuery = (0,createQueryHook/* default */.Z)(createSingleResourceQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/resources/queries/index.ts






/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 99338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58586);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates infinite query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useInfiniteQuery
 */

var createInfiniteQueryHook = function createInfiniteQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useInfiniteQuery.apply */ .N.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createInfiniteQueryHook);

/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ })

}]);